import React, { useState, useEffect, useCallback } from 'react';
import useFilterFacetValues from '../../../../utils/hooks/useFilterFacetValues';
import GenericToggleSwitch from '../GenericToggleSwitch';

interface Props {
  label?: string,
  id: string,
  attribute: string,
  facetFilters: Array<string|Array<string>>,
  setFacetFilters: (filters: Array<string|Array<string>>) => void,
  toggleCallback?: (checked: boolean) => any,
}

const ToggleSwitch: React.FC<Props> = ({
  label,
  id,
  attribute,
  facetFilters,
  setFacetFilters,
  toggleCallback,
}) => {
  const [checked, setChecked] = useState(false);

  const filterFacetValues = useFilterFacetValues(attribute, facetFilters);

  const onChangeCallback = useCallback((isChecked) => {
    if (isChecked) {
      if (Array.isArray(facetFilters) && !facetFilters.includes(`${attribute}:true`)) {
        setFacetFilters([
          ...filterFacetValues(),
          `${attribute}:${true}`,
        ]);
      }
    } else if (Array.isArray(facetFilters) && facetFilters.includes(`${attribute}:true`)) {
      setFacetFilters(filterFacetValues());
      // setFacetFilters(newFacetFilters);
    }
  }, [facetFilters, setFacetFilters, attribute]);

  useEffect(() => {
    if (Array.isArray(facetFilters) && facetFilters.includes(`${attribute}:true`)) {
      if (!checked) {
        setChecked(true);
      }
    } else if (checked) {
      setChecked(false);
    }
  }, [facetFilters]);

  useEffect(() => {
    onChangeCallback(checked);
    if (toggleCallback) {
      toggleCallback(checked);
    }
  }, [checked]);

  return (
    <GenericToggleSwitch
      id={id}
      checked={checked}
      label={label}
      setChecked={setChecked}
      labelClass="d-block font-weight-bold mr-2 mb-0"
      labelLeft
    />
  );
};

export default ToggleSwitch;
